export const URL = "https://api.celiklerenerji.com/api"

const API = {
    // AUTHENTICATION
    "BASE": URL,
    "LOGIN": URL + "/Authentication/Login",
    "REGISTER": URL + "/Authentication/Register",
    "REFRESH": URL + "/Authentication/Refresh",
    // CONTACT
    "CONTACT_GET": URL + "/Contact/Get",
    "CONTACT_UPDATE": URL + "/Contact/Update",
    // CONTACT
    "CONTENT_GET": URL + "/Content/GetSingle",
    "CONTENT_UPDATE": URL + "/Content/Update",
    // DOCUMENT
    "DOCUMENT_GETALL": URL + "/Document/GetAll",
    "DOCUMENT_GET": URL + "/Document/Get",
    "DOCUMENT_GETSLUG": URL + "/Document/GetSlug",
    "DOCUMENT_CREATE": URL + "/Document/Create",
    "DOCUMENT_UPDATE": URL + "/Document/Update",
    "DOCUMENT_SORT": URL + "/Document/Sort",
    "DOCUMENT_DELETE": URL + "/Document/Delete",
    // FORM
    "FORM_GETALL": URL + "/Form/GetAll",
    "FORM_GET": URL + "/Form/Get",
    "FORM_CREATE": URL + "/Form/Create",
    "FORM_UPDATE": URL + "/Form/Update",
    "FORM_DELETE": URL + "/Form/Delete",
    // FORMELEMENT
    "FORM_ELEMENT_GETALL": URL + "/FormElement/GetAll",
    "FORM_ELEMENT_GET": URL + "/FormElement/Get",
    "FORM_ELEMENT_CREATE": URL + "/FormElement/Create",
    "FORM_ELEMENT_UPDATE": URL + "/FormElement/Update",
    "FORM_ELEMENT_DELETE": URL + "/FormElement/Delete",
    // FORMGROUP
    "FORM_GROUP_GETALL": URL + "/FormGroup/GetAll",
    "FORM_GROUP_GET": URL + "/FormGroup/Get",
    "FORM_GROUP_CREATE": URL + "/FormGroup/Create",
    "FORM_GROUP_UPDATE": URL + "/FormGroup/Update",
    "FORM_GROUP_DELETE": URL + "/FormGroup/Delete",
    // FORMRESPONSE
    "FORM_RESPONSE_GETALL": URL + "/FormResponse/GetAll",
    "FORM_RESPONSE_GET": URL + "/FormResponse/Get",
    "FORM_RESPONSE_CREATE": URL + "/FormResponse/Create",
    "FORM_RESPONSE_UPDATE": URL + "/FormResponse/Update",
    "FORM_RESPONSE_DELETE": URL + "/FormResponse/Delete",
    // LANGUAGE
    "LANGUAGE_GETALL": URL + "/Language/GetAll",
    "LANGUAGE_GET": URL + "/Language/Get",
    "LANGUAGE_CREATE": URL + "/Language/Create",
    "LANGUAGE_UPDATE": URL + "/Language/Update",
    "LANGUAGE_DELETE": URL + "/Language/Delete",
    // LOG
    "LOG_GETALL": URL + "/Log/GetAll",
    "LOG_GET": URL + "/Log/Get",
    "LOG_DELETE": URL + "/Log/Delete",
    // MENU
    "MENU_GETALL": URL + "/Menu/GetAll",
    "MENU_GETALLBYGROUP": URL + "/Menu/GetAllByGroup",
    "MENU_GET": URL + "/Menu/Get",
    "MENU_GETSLUG": URL + "/Menu/GetSlug",
    "MENU_CREATE": URL + "/Menu/Create",
    "MENU_UPDATE": URL + "/Menu/Update",
    "MENU_SORT": URL + "/Menu/Sort",
    "MENU_DELETE": URL + "/Menu/Delete",
    // MENUGROUP
    "MENUGROUP_GETALL": URL + "/MenuGroup/GetAll",
    "MENUGROUP_GET": URL + "/MenuGroup/Get",
    "MENUGROUP_CREATE": URL + "/MenuGroup/Create",
    "MENUGROUP_UPDATE": URL + "/MenuGroup/Update",
    "MENUGROUP_SORT": URL + "/MenuGroup/Sort",
    "MENUGROUP_DELETE": URL + "/MenuGroup/Delete",
    // MODULE
    "MODULE_GETALL": URL + "/Module/GetAll",
    "MODULE_GET": URL + "/Module/Get",
    "MODULE_GETALLBYPAGE": URL + "/Module/GetAllByPage",
    "MODULE_GETSLUG": URL + "/Module/GetSlug",
    "MODULE_CREATE": URL + "/Module/Create",
    "MODULE_UPDATE": URL + "/Module/Update",
    "MODULE_SORT": URL + "/Module/Sort",
    "MODULE_DELETE": URL + "/Module/Delete",
    // MODULE_CONTENT
    "MODULE_CONTENT_GETALL": URL + "/ModuleContent/GetAll",
    "MODULE_CONTENT_GET": URL + "/ModuleContent/Get",
    "MODULE_CONTENT_GETSLUG": URL + "/ModuleContent/GetSlug",
    "MODULE_CONTENT_CREATE": URL + "/ModuleContent/Create",
    "MODULE_CONTENT_UPDATE": URL + "/ModuleContent/Update",
    "MODULE_CONTENT_SORT": URL + "/ModuleContent/Sort",
    "MODULE_CONTENT_DELETE": URL + "/ModuleContent/Delete",
    // MODULE_FIELD
    "MODULE_FIELD_GETALL": URL + "/ModuleField/GetAll",
    "MODULE_FIELD_GET": URL + "/ModuleField/Get",
    "MODULE_FIELD_GETSLUG": URL + "/ModuleField/GetSlug",
    "MODULE_FIELD_CREATE": URL + "/ModuleField/Create",
    "MODULE_FIELD_UPDATE": URL + "/ModuleField/Update",
    "MODULE_FIELD_SORT": URL + "/ModuleField/Sort",
    "MODULE_FIELD_DELETE": URL + "/ModuleField/Delete",
    // PAGE
    "PAGE_GETALL": URL + "/Page/GetAll",
    "PAGE_GET": URL + "/Page/Get",
    "PAGE_GETSLUG": URL + "/Page/GetSlug",
    "PAGE_CREATE": URL + "/Page/Create",
    "PAGE_UPDATE": URL + "/Page/Update",
    "PAGE_DELETE": URL + "/Page/Delete",
    // PRODUCT
    "PRODUCT_GETALL": URL + "/Product/GetAll",
    "PRODUCT_GET": URL + "/Product/Get",
    "PRODUCT_GETSLUG": URL + "/Product/GetSlug",
    "PRODUCT_CREATE": URL + "/Product/Create",
    "PRODUCT_UPDATE": URL + "/Product/Update",
    "PRODUCT_SORT": URL + "/Product/Sort",
    "PRODUCT_DELETE": URL + "/Product/Delete",
    // SEO
    "SEO_GETALL": URL + "/Seo/GetAll",
    "SEO_GET": URL + "/Seo/Get",
    "SEO_GETSLUG": URL + "/Seo/GetSlug",
    "SEO_CREATE": URL + "/Seo/Create",
    "SEO_UPDATE": URL + "/Seo/Update",
    "SEO_DELETE": URL + "/Seo/Delete",
    // SETTING
    "SETTING_GET": URL + "/Settings/GetSingle",
    "SETTING_UPDATE": URL + "/Settings/Update",
    // SEND_MAIL
    "SEND_MAIL": URL + "/Mail/Send",
    // SHOWCASE
    "SHOWCASE_GETALL": URL + "/Showcase/GetAll",
    "SHOWCASE_GETALLBYPRODUCT": URL + "/Showcase/GetAllByProduct",
    "SHOWCASE_GETALLBYABOUT": URL + "/Showcase/GetAllByAbout",
    "SHOWCASE_GETALLBYNEWS": URL + "/Showcase/GetAllByNews",
    "SHOWCASE_GETALLBYPAGE": URL + "/Showcase/GetAllByPage",
    "SHOWCASE_GET": URL + "/Showcase/Get",
    "SHOWCASE_GETSLUG": URL + "/Showcase/GetSlug",
    "SHOWCASE_CREATE": URL + "/Showcase/Create",
    "SHOWCASE_UPDATE": URL + "/Showcase/Update",
    "SHOWCASE_DESIGN": URL + "/Showcase/Design",
    "SHOWCASE_SORT": URL + "/Showcase/Sort",
    "SHOWCASE_DELETE": URL + "/Showcase/Delete",
    // SERVICE
    "SERVICE_GETALL": URL + "/Service/GetAll",
    "SERVICE_GET": URL + "/Service/Get",
    "SERVICE_CREATE": URL + "/Service/Create",
    "SERVICE_UPDATE": URL + "/Service/Update",
    "SERVICE_DELETE": URL + "/Service/Delete",
    //SLIDER
    "SLIDER_GETALL": URL + "/Slider/GetAll",
    "SLIDER_GETALLBYGROUP": URL + "/Slider/GetAllByGroup",
    "SLIDER_GET": URL + "/Slider/Get",
    "SLIDER_CREATE": URL + "/Slider/Create",
    "SLIDER_UPDATE": URL + "/Slider/Update",
    "SLIDER_DELETE": URL + "/Slider/Delete",
    "SLIDER_SORT": URL + "/Slider/Sort",
    //SLIDER_CONTENT
    "SLIDERCONTENT_GETALL": URL + "/SliderContent/GetAll",
    "SLIDERCONTENT_GETALLBYSLIDER": URL + "/SliderContent/GetAllBySlider",
    "SLIDERCONTENT_GET": URL + "/SliderContent/Get",
    "SLIDERCONTENT_CREATE": URL + "/SliderContent/Create",
    "SLIDERCONTENT_UPDATE": URL + "/SliderContent/Update",
    "SLIDERCONTENT_DELETE": URL + "/SliderContent/Delete",
    "SLIDERCONTENT_SORT": URL + "/SliderContent/Sort",
    //SLIDER_GROUP
    "SLIDERGROUP_GETALL": URL + "/SliderGroup/GetAll",
    "SLIDERGROUP_GET": URL + "/SliderGroup/Get",
    "SLIDERGROUP_CREATE": URL + "/SliderGroup/Create",
    "SLIDERGROUP_UPDATE": URL + "/SliderGroup/Update",
    "SLIDERGROUP_DELETE": URL + "/SliderGroup/Delete",
    // SOCIALMEDIA
    "SOCIALMEDIA_GETALL": URL + "/SocialMedia/GetAll",
    "SOCIALMEDIA_GET": URL + "/SocialMedia/Get",
    "SOCIALMEDIA_CREATE": URL + "/SocialMedia/Create",
    "SOCIALMEDIA_UPDATE": URL + "/SocialMedia/Update",
    "SOCIALMEDIA_DELETE": URL + "/SocialMedia/Delete",
    // USER
    "USER_GETALL": URL + "/User/GetAll",
    "USER_GET": URL + "/User/Get",
    "USER_UPDATE": URL + "/User/Update",
    "USER_DELETE": URL + "/User/Delete",
    "USER_CHANGE_PASSWORD": URL + "/User/ChangePassord",
    "RESET_PASSWORD": URL + "/User/ResetPassord",
    // USER_PERMISSION
    "USER_PERMISSION_GETALL": URL + "/UserPermission/GetAll",
    "USER_PERMISSION_GET": URL + "/UserPermission/Get",
    "USER_PERMISSION_CREATE": URL + "/UserPermission/Create",
    "USER_PERMISSION_UPDATE": URL + "/UserPermission/Update",
    "USER_PERMISSION_DELETE": URL + "/UserPermission/Delete",
    // VERSIONING
    "VERSIONING_GET": URL + "/Versioning/Get",
    "VERSIONING_UPDATE": URL + "/Versioning/Update",
}

export default API
